"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentLimitsValidationResultMetadataSchema = exports.ComponentLimitsValidationResultEntrySchema = exports.ComponentLimitsValidationResultEntryStatusSchema = exports.ComponentLimitsValidationResultEntryStatus = exports.ComponentLimitsValidationInstanceMetadataSchema = exports.ComponentLimitsValidationResultKey = exports.ComponentLimitsValidationRequirementTypeId = void 0;
const zod_1 = require("zod");
const IBoundaryDefinition_1 = require("../../DesignModels/IBoundaryDefinition");
const BoundaryErrorsDefinition_1 = require("../../DesignModels/BoundaryErrorsDefinition");
const CharacteristicStateSummaryExternal_1 = require("../../CircuitStates/CharacteristicStateSummaryExternal");
exports.ComponentLimitsValidationRequirementTypeId = 'BNDS';
exports.ComponentLimitsValidationResultKey = 'ComponentLimitValidationResult';
exports.ComponentLimitsValidationInstanceMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.ComponentLimitsValidationResultKey),
    referenceDesignator: zod_1.z.string(),
    moduleName: zod_1.z.string().optional(),
    boundaries: IBoundaryDefinition_1.IBoundaryDefinitionWithIdSchema.array(),
});
var ComponentLimitsValidationResultEntryStatus;
(function (ComponentLimitsValidationResultEntryStatus) {
    ComponentLimitsValidationResultEntryStatus["PASS"] = "PASS";
    ComponentLimitsValidationResultEntryStatus["FAIL"] = "FAIL";
    ComponentLimitsValidationResultEntryStatus["UNKNOWN_NET_STATES"] = "UNKNOWN_NET_STATES";
    ComponentLimitsValidationResultEntryStatus["ERROR"] = "ERROR";
})(ComponentLimitsValidationResultEntryStatus || (exports.ComponentLimitsValidationResultEntryStatus = ComponentLimitsValidationResultEntryStatus = {}));
exports.ComponentLimitsValidationResultEntryStatusSchema = zod_1.z.nativeEnum(ComponentLimitsValidationResultEntryStatus);
exports.ComponentLimitsValidationResultEntrySchema = zod_1.z.object({
    errors: zod_1.z.lazy(() => BoundaryErrorsDefinition_1.IBoundaryErrorSchema).array(),
    netValues: zod_1.z
        .object({
        net: zod_1.z.string(),
        characteristics: CharacteristicStateSummaryExternal_1.CharacteristicStateSummaryExternalSchema.array(),
    })
        .array(),
    status: exports.ComponentLimitsValidationResultEntryStatusSchema,
});
exports.ComponentLimitsValidationResultMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.ComponentLimitsValidationResultKey),
    results: zod_1.z.lazy(() => exports.ComponentLimitsValidationResultEntrySchema).array(),
});
//# sourceMappingURL=ComponentLimitsValidationInstanceMetadata.js.map